export enum EarningType {
  GrossEarnings = 'grossEarning',
  NetEarnings = 'netEarning',
}

export const earningTypeOptions = [{
  value: EarningType.GrossEarnings,
  label: 'Gross earnings',
}, {
  value: EarningType.NetEarnings,
  label: 'Net earnings',
}]